import { createElement as rc, useMemo } from 'react';
import Highcharts from 'highcharts';
import _HighchartsReact from 'highcharts-react-official';
import { useTheme } from 'styled-components';
import Chart from './Chart';
import { View, styled, hooks, fromTheme } from 'lib_ui-primitives';
const { useMemoizedObject } = hooks;
const HighchartsReact = _HighchartsReact.default || _HighchartsReact;
HighchartsReact.displayName = 'HighchartsReact';

const Stack = styled(View).attrs({ name: 'VerticalChart' })`
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: ${fromTheme('charts', 'maxWidth')};
    margin: 0 auto;
    margin-top: auto;
`;
const EMPTY_ARRAY = [];
function ColumnsChart(props) {
    const {
        data = EMPTY_ARRAY,
        hNode: { title }
    } = props || { hNode: {} };

    const theme = useTheme();
    const charts = theme.charts;
    const memoizedData = useMemoizedObject(data);
    const options = useMemo(() => {
        const { disabledFontColor, defaultFontColor, chartColors } = theme;
        return {
            chart: {
                type: 'column',
                backgroundColor: 'transparent',
                styledMode: true
            },
            title: { text: '' },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.y}</b>'
            },
            colors: chartColors,
            plotOptions: {
                column: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: false
                    },
                    showInLegend: true,
                    borderRadius: charts.bar.borderRadius,
                    borderWidth: 0
                }
            },
            credits: { enabled: false },
            legend: {
                enabled: true,
                align: 'left',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                labelFormat: '{name} - {y}',
                itemHiddenStyle: { color: disabledFontColor },
                itemHoverStyle: { color: charts.legendHoverColor },
                itemMarginTop: charts.legend.itemSpacing,
                itemStyle: {
                    color: defaultFontColor,
                    fontFamily: charts.legend.labelFont.fontFamily,
                    fontSize: charts.legend.labelFont.fontSize,
                    fontWeight: charts.legend.labelFont.fontWeight
                }
            },
            series: [
                {
                    name: `# ${title}`,
                    colorByPoint: true,
                    showInLegend: false,
                    data: memoizedData.map(x => ({ name: x._id.title, y: x.count }))
                }
            ],
            yAxis: {
                min: 0,
                title: {
                    text: ' '
                },
                allowDecimals: false,
                gridLineColor: charts.axes.gridLineColor,
                gridLineWidth: charts.axes.gridLineWidth,
                labels: {
                    style: {
                        color: charts.axes.labelColor,
                        fontFamily: charts.axes.labelFont.fontFamily,
                        fontSize: charts.axes.labelFont.fontSize
                    }
                }
            },
            xAxis: {
                categories: memoizedData.map(x => x._id?.title),
                labels: {
                    style: {
                        color: charts.axes.labelColor,
                        fontFamily: charts.axes.labelFont.fontFamily,
                        fontSize: charts.axes.labelFont.fontSize
                    }
                }
            }
        };
    }, [memoizedData, title, theme, charts]);

    return rc(
        Stack,
        null,
        rc(HighchartsReact, {
            highcharts: Highcharts,
            options,
            containerProps: { style: { width: '100%' } },
            height: '100%',
            width: '100%'
        })
    );
}

function VerticalChart(props) {
    return Chart(ColumnsChart, props);
}

export default VerticalChart;
